//#region src/index.ts
const ADMIN = "admin";
const BUREAU = "bureau";
const CONFIANCE = "confiance";
const HARD = "hard";
const PERSONNE = "personne";
const SG = "sg";
const SOFT = "soft";
const VIEUX = "vieux";
const INVITE = "invite";
const CA = "ca";
const ACCUEIL_ARTISTE = "accueil-artiste";
const BAR = "bar";
const BARRIERES = "barrieres";
const BEBOO = "beboo";
const CATERING = "catering";
const LOG_ELEC = "elec";
const HUMAIN = "humain";
const LOG_MATOS = "matos";
const PAYANT = "payant";
const SCENE = "scene";
const SECU = "secu";
const SIGNA = "signa";
const RSE = "rse";
const COMMUNICATION = "communication";
const CONCERT = "concert";
const COURSES = "courses";
const CULTURE = "culture";
const DD = "dd";
const DECO = "deco";
const INFORMATIQUE = "informatique";
const PLAIZIR = "plaizir";
const SPONSO = "sponso";
const SPORTS = "sports";
const BDE = "bde";
const CVL = "cvl";
const KARNA = "karna";
const KFET = "kfet";
const ROUEN = "rouen";
const STRASBOURG = "strasbourg";
const HAUTS_DE_FRANCE = "hauts-de-france";
const CONDUCTEUR = "conducteur";
const CONDUCTEUR_FEN = "conducteur-fen";
const VOITURE = "voiture";
const CAMION = "camion";
const FEN = "fen";
const TEAM_ELEC = "team-elec";
const TEAM_MONTAGE = "team-montage";
const TECKOS = "teckos";
const TEAM_BOUFFE = "team-bouffe";
const TEAM_25EME = "25eme";
//#endregion
export { ACCUEIL_ARTISTE, ADMIN, BAR, BARRIERES, BDE, BEBOO, BUREAU, CA, CAMION, CATERING, COMMUNICATION, CONCERT, CONDUCTEUR, CONDUCTEUR_FEN, CONFIANCE, COURSES, CULTURE, CVL, DD, DECO, FEN, HARD, HAUTS_DE_FRANCE, HUMAIN, INFORMATIQUE, INVITE, KARNA, KFET, LOG_ELEC, LOG_MATOS, PAYANT, PERSONNE, PLAIZIR, ROUEN, RSE, SCENE, SECU, SG, SIGNA, SOFT, SPONSO, SPORTS, STRASBOURG, TEAM_25EME, TEAM_BOUFFE, TEAM_ELEC, TEAM_MONTAGE, TECKOS, VIEUX, VOITURE };

//# sourceMappingURL=index.mjs.map